var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutBase", [
    _c(
      "header",
      { attrs: { id: "content__header" } },
      [
        _c("h1", [_vm._v(_vm._s(_vm.resource.name))]),
        _vm._v(" "),
        _vm.resource.can.delete
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: [
                      "saving preview resource",
                      "deleting preview resource",
                    ],
                    expression:
                      "['saving preview resource', 'deleting preview resource']",
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--danger",
                on: {
                  click: function ($event) {
                    return _vm.showDeleteModal()
                  },
                },
              },
              [_vm._v("\n                Delete\n            ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.can.edit
          ? _c(
              "router-link",
              {
                staticClass: "btn btn--primary",
                attrs: {
                  to: {
                    name: "preview-document",
                    params: { insight_id: _vm.resource.id },
                  },
                },
              },
              [_vm._v("\n                Edit\n\t\t\t")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("ul", { staticClass: "grid post-details" }, [
      _vm.resource.createdAt
        ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
            _c("span", { staticClass: "label" }, [_vm._v("Posted")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "h3" },
              [
                _c("SvgIcon", { attrs: { icon: "calendar" } }),
                _vm._v(" " + _vm._s(_vm.resource.createdAt)),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.sectors
        ? _c(
            "li",
            { staticClass: "col-6 col-md-9 detail" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("Sectors")]),
              _vm._v(" "),
              _vm._l(_vm.resource.sectors, function (sector) {
                return _c("span", { staticClass: "sector" }, [
                  _vm._v(_vm._s(sector.name)),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.category
        ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
            _c("span", { staticClass: "label" }, [_vm._v("Category")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "h3" },
              [
                _c("SvgIcon", { attrs: { icon: "category" } }),
                _vm._v(" " + _vm._s(_vm.resource.category.name)),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.type
        ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
            _c("span", { staticClass: "label" }, [_vm._v("Content Type")]),
            _vm._v(" "),
            _c("span", { staticClass: "h3" }, [
              _vm._v(_vm._s(_vm.resource.type)),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "grid" }, [
      _c("div", { staticClass: "col-12 col-md-8" }, [
        _vm.resource.description
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "header" }, [_vm._v("Description")]),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.resource.description) },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.attachments && _vm.resource.attachments.length
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "header" }, [_vm._v("Attachments")]),
              _vm._v(" "),
              _vm.resource.attachments && _vm.resource.attachments.length > 0
                ? _c(
                    "ul",
                    { staticClass: "documents" },
                    _vm._l(_vm.resource.attachments, function (doc) {
                      return _c(
                        "li",
                        [
                          _c("AttachmentDownload", {
                            attrs: { attachment: doc },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-4" }, [
        _vm.resource.member
          ? _c("div", { staticClass: "card card--image" }, [
              _c("img", {
                attrs: { src: `/images/logo/${_vm.resource.member.id}` },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.creator
          ? _c(
              "div",
              { staticClass: "profile-list" },
              [
                _c("p", { staticClass: "profile-list__title" }, [
                  _vm._v("Creator"),
                ]),
                _vm._v(" "),
                _c("UserCard", {
                  attrs: { user: _vm.resource.creator, borderless: true },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }